package fr.frux.shared.presentation

/**
 * Libellé de date relative grossier ("à l'instant" / "il y a 3 h" / "il y a 12 j" / "il y a 4
 * mois"), seul formateur de fraîcheur de l'app (#420) : la fiche arbre (dernière observation,
 * passage humain) et la vignette de liste en dérivent toutes les deux, sans jamais en réécrire un
 * second. Grain volontairement grossier, aucune lib dédiée pour ce besoin ponctuel.
 */
fun relativeAgeLabel(
    epochMillis: Long,
    nowMillis: Long,
): String {
    val elapsedMillis = (nowMillis - epochMillis).coerceAtLeast(0)
    val hours = elapsedMillis / 3_600_000L
    val days = elapsedMillis / 86_400_000L
    val months = elapsedMillis / 2_592_000_000L // 30 jours, approximation assumée
    return when {
        hours < 1 -> "à l'instant"
        hours < 24 -> "il y a $hours h"
        days < 30 -> "il y a $days j"
        else -> "il y a $months mois"
    }
}
